angular.module('jv.candidate.modal.controller', ['jv.Common.Filters'])
    .controller('jvCandidateModalController', ['$scope', '$rootScope','TemplateLoader','jvCandidatesService','$window','jvHireUrlService','jvHireBroadcastSVC',
        function($scope, $rootScope,TemplateLoader,jvCandidatesService,$window,jvHireUrlService,jvHireBroadcastSVC) {
            // Modal Information
            $scope.modals = {
                addToCollection: false,
                changeStatus: false,
                rejectCandidate: false,
                duplicateCandidates: false
            };
            $scope.modalData = {};
            var JV = $window.JV;
            //Used to hide all the modals on the page
            $scope.hideModals = function(broadcastEvent){
                angular.forEach($scope.modals, function(val, key) {
                     $scope.modals[key] = false;
                });

                if (broadcastEvent) {
                    $rootScope.$broadcast('hidingCandidateModals');
                }
            };

            var clearScheduleLocalStorage = function() {
                localStorage.setItem('redirectToListAfterSchedule', false);
                localStorage.removeItem('candidateDetails_toAdvancedScheduler');
                localStorage.removeItem('advancedSchedule_proposedInterviewInformation');
                localStorage.removeItem('advancedSchedule_finalSchedules');
                localStorage.removeItem('advancedSchedule_timeSlots');
            };

            var getApplicationData = function(data, callback) {
                var args = {
                    applicationId : data.applicationId
                };

                jvCandidatesService.getApplicationDetails(args, function(response){
                    var appDetails;
                    if(response.data && response.status === 200){
                        appDetails = response.data;
                    }
                    localStorage.setItem('candidateDetails_toAdvancedScheduler', JSON.stringify(appDetails));
                    callback(appDetails);
                });
            };

            $scope.templates = TemplateLoader.register({
                addToCollection: '/jhire/modules/candidates/modals/addToCollection.html',
                changeStatus: '/jhire/modules/candidates/modals/changeStatus.html',
                rejectCandidate: '/jhire/modules/candidates/modals/rejectCandidate.html',
                sendNote: '/jhire/modules/candidates/modals/sendNote.html',
                bulkResumeDownload: '/jhire/modules/candidates/modals/bulkResumeDownload.html',
                actionValidation: '/jhire/modules/candidates/modals/actionValidation.html',
                duplicateCandidates: '/jhire/modules/candidates/modals/duplicateCandidates.html'
            });

            jvHireBroadcastSVC.subscribe('showBulkResumeDownloadModal', function(event, bulk, value) {
                TemplateLoader.load('bulkResumeDownload').then(function() {
                    $scope.modals.bulkResumeDownload = $scope.modals.bulkResumeDownload || {};
                    $scope.modals.bulkResumeDownload.count = value.appIds.length;
                    $scope.modals.bulkResumeDownload.data = value;
                    $rootScope.$broadcast('showBulkResumeDownloadModalView');
                });
            });

            jvHireBroadcastSVC.subscribe('showDuplicateCandidateModal', function(event,bulk,value){
                $scope.duplicateModal = {};
                TemplateLoader.load('duplicateCandidates').then(function(){
                    $scope.duplicateModal.duplicateItems = value.notmoved;
                    $scope.duplicateModal.successCount = value.count;
                    $scope.duplicateModal.duplicateCount = $rootScope.size(value.notmoved);
                    $scope.duplicateModal.modalTitle = $scope.modals.duplicateCount >1 ?  i18n['DUPLICATE_CANDIDATES_MOVED_MODAL_TITLE_MULTIPLE'] : i18n['DUPLICATE_CANDIDATES_MOVED_MODAL_TITLE_SINGLE'];
                    $scope.duplicateModal.tableTitle = i18n['DUPLICATE_CANDIDATES_MOVED_TABLE_TITLE'];
                    $scope.modals.duplicateCandidates = {
                        show : true
                    };
                });
            });

            jvHireBroadcastSVC.subscribe('showRejectCandidateModal',function(event, bulk, value) {
                if (bulk) {
                    $scope.modalData.appIds = value.appIds;
                    $scope.modalData.name = value.name;
                    $scope.modalData.rejectAll = value.rejectAll;
                    $scope.modalData.moveCandidateEnabled = value.moveCandidateEnabled;
                    $scope.modalData.destinationJobId = value.destinationJobId;
                } else {
                    $scope.modalData = value;
                    $scope.modalData.appId = value.appId;
                    $scope.modalData.candidateEId = value.candidateEId;
                    $scope.modalData.email = value.email;
                    $scope.modalData.isReject = value.isReject;
                    $scope.modalData.moveCandidateEnabled = value.moveCandidateEnabled;
                    $scope.modalData.name = value.name;
                    $scope.modalData.rejectAll = value.rejectAll;
                }
                $scope.modalData.bulk = bulk;
                TemplateLoader.load('rejectCandidate').then(function() {
                    $rootScope.$broadcast('showRejectCandidateModalView');
                });
            });

            jvHireBroadcastSVC.subscribe('showAddToCollectionModal',function(event, value) {
                $scope.modalData.appIds = value.appIds;
                $scope.modalData.name = value.name;
                TemplateLoader.load('addToCollection').then(function(){
                    $rootScope.$broadcast('showAddToCollectionModalView');
                });
            });

            jvHireBroadcastSVC.subscribe('showChangeStatusModal',function(event, value) {
                $scope.modalData.appIds = value.appIds;
                $scope.modalData.name = value.name;
                $scope.modalData.reqId = value.reqId;
                $scope.modalData.currentStatus = value.currentStatus;
                $scope.modalData.displayCurrentStatus = value.displayCurrentStatus;
                if(!value.skipModalView){
                    TemplateLoader.load('changeStatus').then(function(){
                        $rootScope.$broadcast('showChangeStatusModalView');
                    });
                }else{
                    TemplateLoader.load('changeStatus').then(function(){
                        $rootScope.$broadcast('postChangeStatus', value);
                    });
                }
            });

            jvHireBroadcastSVC.subscribe('showSendNoteModal', function(event, value) {
                $scope.modalData.appIds = value.appIds;
                $scope.modalData.name = value.name;
                TemplateLoader.load('sendNote').then(function(){
                    $rootScope.$broadcast('showSendNoteModalView');
                });
            });

            jvHireBroadcastSVC.subscribe('actionValidation', function(event,data) {
                TemplateLoader.load('actionValidation').then(function() {
                    $scope.flags.loading = false;
                    $scope.modals.actionValidation = data;
                });
            });

            jvHireBroadcastSVC.subscribe('requestAvailability', function(event, data) {
                clearScheduleLocalStorage();

                getApplicationData(data, function(){
                    $window.location.href = $window.jvUrls.jhire +
                    '/modules/candidates/details/workflow/selfScheduler.html#/' +
                    'scheduler/'+data.applicationId +
                    '/' + data.stateId;
                });
            });

            jvHireBroadcastSVC.subscribe('showScheduler', function(event, data) {
                if(data){
                    clearScheduleLocalStorage();

                    var applicationId = data.applicationId;
                    var mode = data.mode;
                    var stateId = data.stateId;
                    var jobId = data.jobId;

                    getApplicationData(data, function(){
                        jvCandidatesService.redirectToScheduler(data, function(response){
                            if(response && response.status === 200){
                                var step  = response.data.workflowActivities;
                                var hasAdvancedSchedulerEnabled = step.model.advancedSchedulerEnabled;
                                var interviewType = step.workflowElementInfo.metaModel.interviewStatus;
                                if(JV && JV.Person && JV.Person.Global){
                                    JV.Person.Global.grid.removeLoadingState();
                                }
                                if($window.enableSelfScheduling && mode !== 'modifyMessage' && interviewType ==='Schedule'){
                                    jvHireUrlService.navigateToCandidateSelfScheduler(applicationId,stateId,jobId);
                                }else{
                                    if (!hasAdvancedSchedulerEnabled ||
                                            (hasAdvancedSchedulerEnabled && (mode === 'modifyMessage' || mode === 'modifySchedule')) ||
                                            (hasAdvancedSchedulerEnabled && (interviewType === 'Deadline' || interviewType === 'NoSchedule')) ) {
                                        //redirect to basic scheduler
                                        jvHireUrlService.navigateToCandidateScheduler(applicationId,stateId);
                                    }else {
                                        // Change the URL to the new Advanced Scheduler page
                                        $window.location.href = jvHireUrlService.navigateToCandidateSmartScheduler({
                                            appid: applicationId,
                                            wfsid: stateId,
                                            jobid: jobId
                                        },'/interviewInformation');
                                    }
                                }
                            }
                        });
                    });
                }
            });
        }
]);
